import React, { type ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

export function XCircleFillIcon({ className, ...props }: React.ComponentProps<'svg'>): ReactNode {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={twMerge('text-danger', className)}
      {...props}
    >
      <g clipPath="url(#clip0_1583_10944)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.0003 8.00033C14.0003 4.68662 11.314 2.00033 8.00033 2.00033C4.68662 2.00033 2.00033 4.68662 2.00033 8.00033C2.00033 11.314 4.68662 14.0003 8.00033 14.0003C11.314 14.0003 14.0003 11.314 14.0003 8.00033ZM10.4717 5.52897C10.2113 5.26862 9.78932 5.26862 9.52897 5.52897L8.00033 7.05762L6.47168 5.52897L6.4209 5.4834C6.15905 5.26983 5.77305 5.28489 5.52897 5.52897C5.28489 5.77305 5.26983 6.15905 5.4834 6.4209L5.52897 6.47168L7.05762 8.00033L5.52897 9.52897C5.26862 9.78932 5.26862 10.2113 5.52897 10.4717C5.78932 10.732 6.21133 10.732 6.47168 10.4717L8.00033 8.94303L9.52897 10.4717L9.57975 10.5173C9.8416 10.7308 10.2276 10.7158 10.4717 10.4717C10.7158 10.2276 10.7308 9.8416 10.5173 9.57975L10.4717 9.52897L8.94303 8.00033L10.4717 6.47168C10.732 6.21133 10.732 5.78932 10.4717 5.52897Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.00033 2.00033C11.314 2.00033 14.0003 4.68662 14.0003 8.00033C14.0003 11.314 11.314 14.0003 8.00033 14.0003C4.68662 14.0003 2.00033 11.314 2.00033 8.00033C2.00033 4.68662 4.68662 2.00033 8.00033 2.00033ZM8.00033 15.3337C12.0504 15.3337 15.3337 12.0504 15.3337 8.00033C15.3337 3.95024 12.0504 0.666992 8.00033 0.666992C3.95024 0.666992 0.666992 3.95024 0.666992 8.00033C0.666992 12.0504 3.95024 15.3337 8.00033 15.3337Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1583_10944">
          <rect width="16" height="16" fill="var(--color-white)" />
        </clipPath>
      </defs>
    </svg>
  )
}
